import type { Label, Participant, ParticipantPaymentStatus } from '@/scopes/account/group-responsible/domain/types'

export function getParticipantStatusLabel(participant: Participant): Label {
  if (participant.isCancelled) {
    return {
      text: 'common_cancelled',
      type: 'info',
    }
  }

  const labelMap: Record<ParticipantPaymentStatus, Label> = {
    not_paid: {
      text: 'groups_responsible_not_paid',
      type: 'error',
    },
    partial_paid: {
      text: 'groups_responsible_partial_paid',
      type: 'warning',
    },
    paid: {
      text: 'groups_responsible_paid',
      type: 'success',
    },
    refund: {
      text: 'groups_responsible_refund',
      type: 'info',
    },
  }

  return labelMap[participant.paymentStatus]
}
